// Placeholder voor stappen 3-8: features die nog gebouwd worden.

import { useTranslation } from "react-i18next";

interface Props {
  titleKey: string;
  titleDefault: string;
  bodyKey: string;
  bodyDefault: string;
  onBack: () => void;
  onSkip: () => void;
}

export function PlaceholderStep({ titleKey, titleDefault, bodyKey, bodyDefault, onBack, onSkip }: Props) {
  const { t } = useTranslation();
  return (
    <article className="bg-white rounded-2xl border border-neutral-200 p-6 sm:p-8">
      <div className="inline-block px-2 py-0.5 mb-3 bg-amber-50 text-amber-800 text-xs font-medium rounded">
        {t("onboarding.placeholder.label", "Toekomstige feature")}
      </div>
      <h2 className="text-2xl font-semibold mb-2">{t(titleKey, titleDefault)}</h2>
      <p className="text-neutral-700 mb-6">{t(bodyKey, bodyDefault)}</p>

      <div className="flex gap-3">
        <button
          type="button"
          onClick={onBack}
          className="px-4 py-2.5 text-neutral-700 hover:bg-neutral-100 rounded-lg"
        >
          ← {t("back", "Terug")}
        </button>
        <button
          type="button"
          onClick={onSkip}
          className="flex-1 px-4 py-2.5 bg-neutral-100 hover:bg-neutral-200 text-neutral-700 rounded-lg"
        >
          {t("onboarding.skipForNow", "Sla over voor nu")} →
        </button>
      </div>
    </article>
  );
}
